import React, { useState } from 'react';

const SubscriptionStatus = ({ subscription }) => { // Added subscription prop
  const [hovered, setHovered] = useState(false);

  // Determine plan-specific styles and text
  
  return (
    <div 
      className="mb-8 bg-dark-600 rounded-2xl p-0 overflow-hidden transform-gpu hover:scale-[1.01] transition-medium"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {/* Top gradient bar */}
      <div className="h-1.5 bg-gradient-to-r from-accent-purple via-accent-blue to-accent-purple animate-pulse-slow"></div>
      
      <div className="p-5 flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="flex items-center group">
          {/* Gem icon with gradient background */}
           <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-accent-purple to-accent-blue flex items-center justify-center mr-4 transform-gpu group-hover:rotate-12 transition-medium">
             <i className="fas fa-gem text-xl group-hover:animate-spin transition-medium"></i>
           </div>
           <div>
            <h3 className={`font-bold text-lg group-hover:animate-pulse-text ${
              subscription?.type === 'Premium' ? 'gradient-text-premium' :
              subscription?.type === 'Professional' ? 'gradient-text-pro' :
              subscription?.type === 'VIP' ? 'text-accent-yellow' : 'text-gray-200' // Default/Free
            }`}>{subscription?.type || 'Current'} Member</h3>
            <p className="text-sm text-gray-400 group-hover:text-gray-300 transition-medium">
              {subscription?.type === 'Professional' ? 'You have access to all features!' :
               subscription?.type === 'Premium' ? 'Unlock more features by upgrading to Professional' :
               subscription?.type === 'VIP' ? 'Unlock more features by upgrading to Premium' :
               'Upgrade to a paid plan to unlock more features.'}
            </p>
           </div>
         </div>
 
         <div className="w-full md:w-1/2">
           {/* Progress bar labels */}
           <div className="flex justify-between text-xs mb-1">
            <span className={`transition-medium ${subscription?.type === 'Free' ? 'text-accent-green font-medium' : 'group-hover:text-accent-green'}`}>Free</span>
            <span className={`transition-medium ${subscription?.type === 'Premium' ? 'text-accent-purple font-medium group-hover:scale-110' : 'text-gray-400 group-hover:text-accent-purple'}`}>Premium</span>
            <span className={`transition-medium ${subscription?.type === 'Professional' ? 'text-accent-pink font-medium group-hover:scale-110' : 'text-gray-400 group-hover:text-accent-pink'}`}>Professional</span>
           </div>
 
           {/* Progress bar with markers */}
          <div className="w-full bg-dark-400 rounded-full h-2.5 relative">
            {/* 1/3 marker */}
            <div className="absolute top-0 left-0 h-full w-1/3 border-r-2 border-dark-600"></div>
            {/* 2/3 marker */}
            <div className="absolute top-0 left-0 h-full w-2/3 border-r-2 border-dark-600"></div>
             {/* Progress fill */}
             <div
              className={`h-2.5 rounded-full transition-all duration-500 ease-out ${
                subscription?.type === 'Professional' ? 'w-full bg-gradient-to-r from-accent-green via-accent-purple to-accent-pink' :
                subscription?.type === 'Premium' ? `${hovered ? 'w-2/3' : 'w-[66%]'} bg-gradient-to-r from-accent-green to-accent-purple` :
                subscription?.type === 'VIP' ? `${hovered ? 'w-1/3' : 'w-[33%]'} bg-gradient-to-r from-accent-green to-accent-yellow` :
                'w-0 bg-accent-free' // Free plan remains, as w-0 makes bg color irrelevant
              }`}
            ></div>
          </div>
        </div>
      </div>
    </div>
   );
 };
 
SubscriptionStatus.defaultProps = {
  subscription: { type: 'Free' } // Provide a default to prevent errors if subscription is null/undefined
};

export default SubscriptionStatus;